import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import emailjs from "emailjs-com";

const EmailForm = () => {
  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [message, setMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    const templateParams = {
      client_name: clientName,
      client_email: clientEmail,
      message: message,
    };

    emailjs
      .send(
        "service_sz4w3df",
        "template_yv1e8um",
        templateParams,
        "evd7kBDvAOUjHLOXp"
      )
      .then((response) => {
        console.log("Email sent successfully!", response.status, response.text);
        setSuccessMessage(
          "✅ Thank you for contacting us! We’ve received your message and will respond within 24 hours."
        );
        setClientName("");
        setClientEmail("");
        setMessage("");
      })
      .catch((error) => {
        console.log("Failed to send email. Error: ", error);
      });
  };

  return (
    <Container>
      <ContactCard>
        <InfoSection>
          <h1>Contact Passport Assistance</h1>
          <p>
            <strong>Note:</strong> We are not affiliated with the Indian
            Government. We’re a private consultancy offering help with:
          </p>
          <ul>
            <li>New Passport Applications</li>
            <li>Reissue of Passports</li>
            <li>Document Assistance</li>
            <li>Appointment Scheduling</li>
          </ul>
          <p>
            Fill out the form below, and our team will respond within 24 hours.
          </p>
        </InfoSection>

        <FormSection onSubmit={sendEmail}>
          <h2>Request Assistance</h2>
          <Field>
            <label htmlFor="clientName">Full Name</label>
            <input
              type="text"
              id="clientName"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              required
            />
          </Field>
          <Field>
            <label htmlFor="clientEmail">Email Address</label>
            <input
              type="email"
              id="clientEmail"
              value={clientEmail}
              onChange={(e) => setClientEmail(e.target.value)}
              required
            />
          </Field>
          <Field>
            <label htmlFor="message">Your Message</label>
            <textarea
              id="message"
              rows="5"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </Field>
          <Button type="submit">Send Message</Button>
          {successMessage && <Success>{successMessage}</Success>}
        </FormSection>
      </ContactCard>
    </Container>
  );
};

export default EmailForm;
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  background: transparent;
  min-height: 100vh;
  padding: 3rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContactCard = styled.div`
  background: #1c1c1c;
  border-radius: 12px;
  padding: 2rem;
  max-width: 1100px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 2rem;
  color: #f1f1f1;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 0.6s ease-out;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const InfoSection = styled.div`
  flex: 1;

  h1 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
    color: #ffffff;
  }

  p {
    font-size: 1rem;
    color: #ccc;
    margin-bottom: 1rem;
    line-height: 1.5;
  }

  ul {
    padding-left: 1.2rem;
    list-style: disc;
    margin-bottom: 1rem;
    color: #d1d1d1;
  }

  strong {
    color: #5b91f3;
  }
`;

const FormSection = styled.form`
  flex: 1;
  display: flex;
  flex-direction: column;

  h2 {
    font-size: 1.5rem;
    margin-bottom: 1.2rem;
    color: #ffffff;
  }
`;

const Field = styled.div`
  margin-bottom: 1rem;

  label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #d0d0d0;
  }

  input,
  textarea {
    width: 100%;
    padding: 0.75rem;
    border-radius: 6px;
    background: #111;
    border: 1px solid #333;
    color: #fff;
    font-size: 1rem;

    &:focus {
      outline: none;
      border-color: #5b91f3;
    }
  }

  textarea {
    resize: vertical;
  }
`;

const Button = styled.button`
  background: linear-gradient(90deg, #4e54c8, #8f94fb);
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 1rem;
  color: #fff;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background: #5b91f3;
    transform: translateY(-1px);
  }
`;

const Success = styled.p`
  margin-top: 1rem;
  color: #4caf50;
  font-weight: 600;
`;
